import Header from '../components/header'; // Adjust path if needed

import React, { useState, useEffect } from 'react';
// If you don't have lucide-react installed, you can remove these imports
// and replace the icon components with simple elements

const LaunchPage = () => {
  const [days, setDays] = useState(0);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(''); 
  const launchDate = new Date('2024-04-01');

  useEffect(() => {
    const calculateDaysUntilLaunch = () => {
      const now = new Date();
      const difference = launchDate - now;
      const daysRemaining = Math.ceil(difference / (1000 * 60 * 60 * 24));
      setDays(daysRemaining);
    };

    calculateDaysUntilLaunch();
    const timer = setInterval(calculateDaysUntilLaunch, 1000 * 60 * 60);

    return () => clearInterval(timer);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('success'); 
    setEmail('');
  };

  return (
    <div className="launch-page">
      {/* Banner Section with Background Image */}
      <div className="banner-section">
        {/* Dark overlay to ensure text is readable */}
        <div className="banner-overlay"></div>
        
        {/* Navigation Header - placed inside the banner but above the overlay (due to z-index) */}
        <div className="nav-container">
          <Header />
          
          <div className="header-container">
            <div className="logo">
              <a href="/">StoreToyou</a>
            </div>
            <nav className="nav">
              <ul className="nav-list">
                <li><a href="#features">Features</a></li>
                <li><a href="#how-it-works">How It Works</a></li>
                <li><a href="#contact">Contact</a></li>
                <li><a href="/login" className="login-button">Login</a></li>
              </ul>
            </nav>
          </div>
        </div>

        {/* Hero content on the banner */}
        <div className="hero-banner">
          <h1>Discover Local Stores in Kelowna</h1>
          <p>Connect with the best local businesses in your community on a Digital  Mainstreet</p>
          <div className="banner-buttons">
          <a href="/createstore" className="banner-cta">Create Your Storefront</a>
          <a href="/home" className="banner-cta secondary">Find Local Businesses</a>
        </div>
        </div>
      </div>

      <div className="container">
        {/* Hero Section */}
        <div className="hero">
          <h1 className="hero-title">
            Your Digital Storefront<span>In Your Community</span>
          </h1>
          <p className="hero-subtitle">
            StoreToyou creates beautiful Digital storefronts that connect local businesses 
            with customers in their city and region. Showcase your products and services 
            where your community is already looking.
          </p>
          
          {/* Current Cities Section */}
          <h2 className="section-title mt-5">Current Cities</h2>
          <div className="city-banner-container city-banner-left">
            <a href="/city/kelowna" className="city-banner">
              <img 
                src="https://i.imgur.com/XivQ2sR.png" 
                alt="Kelowna City" 
                className="city-image" 
              />
            </a>
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="newsletter">
          <div className="newsletter-content">
            <div className="icon">
              {/* Mail icon replacement */}
              <svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            <h2 className="newsletter-title">
              Be First to Know When We Launch
            </h2>
            <p className="newsletter-text">
              Join our newsletter to receive updates about our launch and early access opportunities.
            </p>
            <form onSubmit={handleSubmit} className="newsletter-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
              <button type="submit">
                Sign Up
              </button>
            </form>
            {status === 'success' && (
              <div className="success-message">
                Thanks for signing up! We'll keep you updated about our launch.
              </div>
            )}
          </div>
        </div>

        {/* Launch Counter */}
        <div className="counter">
          <div className="counter-content">
            <h2 className="counter-title">
              Launching in {days} Days
            </h2>
            <p className="counter-text">
              Join the revolution in local business discovery
            </p>
          </div>
        </div>

        {/* Features Grid */}
        <div id="features" className="features">
          <div className="feature-card">
            <div className="icon">
              {/* Building icon replacement */}
              <svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
                <line x1="12" y1="6" x2="12" y2="6.01"></line>
                <line x1="12" y1="10" x2="12" y2="10.01"></line>
                <line x1="12" y1="14" x2="12" y2="14.01"></line>
                <line x1="12" y1="18" x2="12" y2="18.01"></line>
              </svg>
            </div>
            <h3 className="feature-title">Virtual Storefronts</h3>
            <p className="feature-text">
              Create a beautiful online presence that showcases your products and services with our 
              Instagram-style interface
            </p>
          </div>
          
          <div className="feature-card">
            <div className="icon">
              {/* Map Pin icon replacement */}
              <svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
            </div>
            <h3 className="feature-title">Local Discovery</h3>
            <p className="feature-text">
              Connect with customers in your city and region through our 
              location-based platform
            </p>
          </div>

          <div className="feature-card">
            <div className="icon">
              {/* Globe icon replacement */}
              <svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="2" y1="12" x2="22" y2="12"></line>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
              </svg>
            </div>
            <h3 className="feature-title">Regional Reach</h3>
            <p className="feature-text">
              Expand your customer base while staying connected to your local community
            </p>
          </div>
        </div>

        {/* How It Works */}
        <div id="how-it-works" className="how-it-works">
          <h2 className="section-title">
            How StoreToyou Works
          </h2>
          <div className="columns">
            <div className="column">
              <h3 className="column-title">For Businesses</h3>
              <ul className="list">
                <li>Create your virtual storefront with our easy-to-use platform</li>
                <li>Upload and manage your products with our dashboard</li>
                <li>Connect with customers in your city and surrounding regions</li>
                <li>Share your unique city-based URL (e.g., storetoyou.ca/kelowna/yourstore)</li>
              </ul>
            </div>
            <div className="column">
              <h3 className="column-title">For Customers</h3>
              <ul className="list">
                <li>Discover local businesses in your city and region</li>
                <li>Browse products through our visual interface</li>
                <li>Support your local business community</li>
                <li>Find unique products and services near you</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div id="contact" className="contact-section">
          <h2 className="section-title">Contact Us</h2>
          <p className="contact-text">Have questions about StoreToyou? We'd love to hear from you!</p>
          <p className="contact-email">Email: <a href="mailto:info@storetoyou.ca">info@storetoyou.ca</a></p>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p>&copy; 2024 StoreToyou. All rights reserved.</p>
        </div>
      </footer>
      
      {/* CSS styles */}
      <style jsx>{`
        .launch-page {
          min-height: 100vh;
          background: linear-gradient(to bottom, #e6f0ff, #ffffff);
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
          color: #333;
        }

        /* Banner Section */
        .banner-section {
          position: relative;
          height: 100vh;
          width: 100%;
          background-image: url('https://i.imgur.com/05zwRJK.jpeg');
          background-size: cover;
          background-position: center;
          display: flex;
          flex-direction: column;
        }

        .banner-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.4);
          z-index: 1;
        }

        .nav-container {
          position: relative;
          z-index: 5;
        }

        .header-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 1rem 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          z-index: 5;
        }

        .logo a {
          font-size: 1.5rem;
          font-weight: 700;
          color: white;
          text-decoration: none;
        }

        .nav-list {
          display: flex;
          list-style: none;
          margin: 0;
          padding: 0;
          gap: 2rem;
        }

        .nav-list li a {
          color: white;
          text-decoration: none;
          font-weight: 500;
          transition: opacity 0.2s;
        }

        .nav-list li a:hover {
          opacity: 0.8;
        }

        .login-button {
          background-color: white;
          color: #333 !important;
          padding: 0.5rem 1rem;
          border-radius: 0.25rem;
          transition: background-color 0.2s;
        }

        .login-button:hover {
          background-color: #f0f0f0;
        }

        /* Hero Banner */
        .hero-banner {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          padding: 0 2rem;
          position: relative;
          z-index: 2;
          color: white;
        }

        .hero-banner h1 {
          font-size: 3rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        }

        .hero-banner p {
          font-size: 1.25rem;
          max-width: 800px;
          margin: 0 auto 2rem;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        }

        .banner-buttons {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
          justify-content: center;
        }

        .banner-cta {
          display: inline-block;
          padding: 0.875rem 2rem;
          background-color: #2563eb;
          color: white;
          font-size: 1.125rem;
          font-weight: 600;
          border-radius: 0.5rem;
          text-decoration: none;
          transition: background-color 0.2s;
        }

        .banner-cta:hover {
          background-color: #1d4ed8;
        }
        
        .banner-cta.secondary {
          background-color: transparent;
          color: white;
          border: 2px solid white;
        }
        
        .banner-cta.secondary:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
        
        /* Responsive Styling for Banner */
        @media (max-width: 768px) {
          .hero-banner h1 {
            font-size: 2.5rem;
          }
          
          .hero-banner p {
            font-size: 1.125rem;
          }
          
          .banner-cta {
            padding: 0.75rem 1.5rem;
            font-size: 1rem;
          }
          
          .banner-buttons {
            gap: 0.75rem;
          }
          
          .nav-list {
            gap: 1rem;
          }
        }
        
        @media (max-width: 640px) {
          .header-container {
            flex-direction: column;
            padding: 1rem;
          }
          
          .logo {
            margin-bottom: 1rem;
          }
          
          .nav-list {
            flex-wrap: wrap;
            justify-content: center;
            gap: 1rem;
          }
          
          .hero-banner h1 {
            font-size: 2rem;
          }
          
          .hero-banner p {
            font-size: 1rem;
          }
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 4rem 2rem;
        }
        
        .hero {
          text-align: center;
          margin-bottom: 2.5rem;
        }
        
        .hero-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          color: #333;
        }
        
        .hero-title span {
          display: block;
          color: #2563eb;
        }
        
        .hero-subtitle {
          font-size: 1.25rem;
          max-width: 800px;
          margin: 0 auto 2rem;
          color: #666;
        }
        
        /* City Banner */
        .city-banner-container {
          margin: 0 auto 4rem;
          max-width: 900px;
        }
        
        .city-banner-left {
          margin-left: 0;
          margin-right: auto;
          padding-left: 2rem;
          width: 70%;
        }
        
        .city-banner {
          display: block;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
        }
        
        .city-banner:hover {
          transform: translateY(-5px);
        }
        
        .city-image {
          width: 100%;
          height: auto;
          display: block;
        }
        
        .newsletter {
          background-color: #2563eb;
          border-radius: 1rem;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
          padding: 2rem;
          margin-bottom: 4rem;
          color: white;
        }
        
        .newsletter-content {
          text-align: center;
          max-width: 800px;
          margin: 0 auto;
        }
        
        .icon {
          margin-bottom: 1rem;
          display: flex;
          justify-content: center;
        }
        
        .newsletter-title {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: 1rem;
        }
        
        .newsletter-text {
          margin-bottom: 1.5rem;
        }
        
        .newsletter-form {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-bottom: 1rem;
        }
        
        @media (min-width: 640px) {
          .newsletter-form {
            flex-direction: row;
            justify-content: center;
          }
        }
        
        .newsletter-form input {
          padding: 0.75rem 1rem;
          border-radius: 0.5rem;
          border: none;
          width: 100%;
          max-width: 24rem;
          color: #333;
        }
        
        .newsletter-form button {
          padding: 0.75rem 1.5rem;
          background-color: white;
          color: #2563eb;
          font-weight: 600;
          border-radius: 0.5rem;
          border: none;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        
        .newsletter-form button:hover {
          background-color: #f8f9fa;
        }
        
        .success-message {
          margin-top: 1rem;
          padding: 1rem;
          background-color: rgba(255, 255, 255, 0.1);
          border: 1px solid white;
          border-radius: 0.5rem;
        }
        
        .counter {
          background-color: white;
          border-radius: 1rem;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
          padding: 2rem;
          margin-bottom: 4rem;
        }
        
        .counter-content {
          text-align: center;
        }
        
        .counter-title {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: 1rem;
          color: #333;
        }
        
        .counter-text {
          color: #666;
        }
        
        .features {
          display: grid;
          grid-template-columns: 1fr;
          gap: 2rem;
          margin-bottom: 4rem;
          scroll-margin-top: 5rem;
        }
        
        @media (min-width: 768px) {
          .features {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        
        @media (min-width: 1024px) {
          .features {
            grid-template-columns: repeat(3, 1fr);
          }
        }
        
        .feature-card {
          background-color: white;
          border-radius: 0.75rem;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          padding: 1.5rem;
        }
        
        .feature-card .icon {
          color: #2563eb;
          margin-bottom: 1rem;
        }
        
        .feature-title {
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
          color: #333;
        }
        
        .feature-text {
          color: #666;
        }
        
        .how-it-works {
          background-color: white;
          border-radius: 1rem;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
          padding: 2rem;
          margin-bottom: 4rem;
          scroll-margin-top: 5rem;
        }
        
        .section-title {
          font-size: 1.875rem;
          font-weight: 700;
          text-align: center;
          margin-bottom: 2rem;
          color: #333;
        }
        
        .mt-5 {
          margin-top: 3rem;
        }
        
        .columns {
          display: grid;
          grid-template-columns: 1fr;
          gap: 2rem;
        }
        
        @media (min-width: 768px) {
          .columns {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        
        .column-title {
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 1rem;
          color: #333;
        }
        
        .list {
          list-style-type: none;
          padding: 0;
          color: #666;
        }
        
        .list li {
          margin-bottom: 0.5rem;
          padding-left: 1.5rem;
          position: relative;
        }
        
        .list li:before {
          content: "•";
          position: absolute;
          left: 0;
          color: #2563eb;
        }

        /* Contact Section */
        .contact-section {
          text-align: center;
          margin-bottom: 4rem;
          padding: 2rem;
          background-color: white;
          border-radius: 1rem;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
          scroll-margin-top: 5rem;
        }

        .contact-text {
          margin-bottom: 1rem;
          color: #666;
        }

        .contact-email {
          font-weight: 500;
        }

        .contact-email a {
          color: #2563eb;
          text-decoration: none;
        }

        /* Footer */
        .footer {
          background-color: #1e40af;
          color: white;
          padding: 2rem 0;
        }

        .footer-content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
          text-align: center;
        }
      `}</style>
    </div>
  );
};

export default LaunchPage;